// Global type definitions

export interface GlobalConfig {
  isPipOnly: boolean;
  streamRoomMountPointId: string | null;
  cmsMountPointId: string;
  openWindowType: string | null;
  liveSellingPageUrl: string | null;
  localStreamId: string;
}

export interface HandsupCMSConfig {
  PIP_ONLY?: boolean;
  STREAM_ROOM_MOUNT_POINT_ID?: string;
  CMS_MOUNT_POINT_ID?: string;
  OPEN_WINDOW_TYPE?: string;
  RETURN_LIVE_SELLING_PAGE_URL?: string;
}

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    HANDSUP_CMS?: {
      init?: HandsupCMSConfig;
    };
  }
}

export const LIVE_STATUS = {
  UNKNOWN: 'UNKNOWN',
  UNPUBLISHED: 'UNPUBLISHED',
  LIVE: 'LIVE',
  WAIT_REPLAY_READY: 'WAIT_REPLAY_READY',
  REPLAY: 'REPLAY',
  END: 'END',
} as const;

export type LiveStatusType = typeof LIVE_STATUS[keyof typeof LIVE_STATUS];
